
import { Body2Reg, Subtitle1 } from '../../../config/designSystem/typography';
import { COLORS } from '../../../config/designSystem/Colors';
import { FC } from 'react';
import { Feather } from '@expo/vector-icons';
import { Image, StyleSheet, TouchableOpacity, View } from 'react-native';
import { SPACING } from '../../../config/designSystem/Spacing';

interface TherapistCardProps {
  title: string;
  subtitle: string;
  picture?: string;
  onPress?: () => void;
}
export const TherapistCard: FC<TherapistCardProps> = ({
  title,
  subtitle,
  picture,
  onPress,
}: TherapistCardProps) => {

  return (
    <View style={styles.TherapistCard}>
      <TouchableOpacity
        style={styles.TherapistCardRow}
        onPress={onPress}
      >
        <View style={styles.Avatar}>
          {picture !== undefined ?
            <Image
              width={40}
              height={40}
              resizeMode='contain'
              style={styles.Image}
              source={{uri: picture}}
            />
            :
            <Feather
              name="user"
              size={26}
              color={COLORS.content.accent}
              style={{alignSelf: 'center'}}
            />
          }
        </View>
        <View style={styles.TherapistCardContent}>
          <Subtitle1>
            {title}
          </Subtitle1>
          <Body2Reg>
            {subtitle}
          </Body2Reg>
        </View>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  TherapistCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: SPACING['sp-16'],
    padding: SPACING['sp-16'],
    borderRadius: SPACING['sp-12'],
    backgroundColor: COLORS.surface.contrast,
    shadowColor: COLORS.brand[500],
    shadowOffset: {height: 4, width: 0},
    shadowOpacity: 0.1
  },
  TherapistCardRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    alignSelf: 'stretch',
  },
  TherapistCardContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: 1
  },
  Avatar: {
    width: SPACING['sp-40'],
    height: SPACING['sp-40'],
    backgroundColor: COLORS.surface.accent,
    justifyContent: 'center',
    borderRadius: 99,
  },
  Image: {
    borderRadius: 99,
    alignSelf: 'center',
    height: '100%',
    width: '100%'
  }
});


